export default __webpack_public_path__ + "static/media/bg-banner-search.bc2141ed.png";